import { render, staticRenderFns } from "./ItemPoolFilters.vue?vue&type=template&id=2bd6c0f8&scoped=true&"
import script from "./ItemPoolFilters.vue?vue&type=script&lang=js&"
export * from "./ItemPoolFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6c0f8",
  null
  
)

export default component.exports